module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "panel-view"
  }, [_c('CellTips', [_vm._v("普通panel")]), _vm._v(" "), _c('Panel', {
    attrs: {
      "link-obj": _vm.linkObjs,
      "title": "Panel 1",
      "more-info": "show more",
      "more-link": "#"
    }
  }), _vm._v(" "), _c('CellTips', [_vm._v("仅带标题")]), _vm._v(" "), _c('Panel', {
    attrs: {
      "title-only": "",
      "link-obj": _vm.linkObjs,
      "title": "Panel 1",
      "more-info": "show more",
      "more-link": "#"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-3cadbc1d!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/panelView.vue
// module id = 230
// module chunks = 0